<script>
    import Scroller from '@sveltejs/svelte-scroller';
    import IlloTurfSvg from './IlloTurfSvg.svelte';

    let index;
	let offset;
	let progress;

</script>

<Scroller top="{1}" bottom="{1}" bind:index bind:offset bind:progress>
    <div slot="background">
        <div class="wrapper center">
            <IlloTurfSvg {offset}/>
        </div>
    </div>
    <div slot="foreground">
        <section></section>
    </div>
</Scroller>

<style lang="scss">
    @import "@propublica/pp-v5-shared/src/css/column-setter-and-deps";
    .wrapper {
        max-width: 400px;
    }

	[slot="foreground"] {
		pointer-events: none;
	}

	[slot="foreground"] section {
		pointer-events: all;
	}
	
	section {
		height: 250px;

        @include breakpoint-max(sm) {
            height: 200px;
        }
	}
</style>